import React from 'react';
import { GiftIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { MOCKUP_URL } from '../../data/content';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-navy-900 text-white" data-id="element-207" data-mp="cvbexird99oe">
      <div className="bg-alert px-4 py-2 text-center text-xs font-bold uppercase tracking-wide sm:text-sm" data-id="element-208" data-mp="huxptljq2du1">
        Professional use only · For qualified clinicians
      </div>

      <div className="mx-auto grid max-w-6xl items-center gap-8 px-4 pb-14 pt-8 sm:pt-12 lg:grid-cols-2 lg:gap-12 lg:pb-20 lg:pt-16" data-id="element-209" data-mp="mrxz05bvbwpd">
        <div className="flex flex-col items-center text-center lg:items-start lg:text-left" data-id="element-210" data-mp="vlu8ajjxpend">
          <p className="mb-4 text-sm font-semibold text-accent-300 sm:text-base" data-id="element-211" data-mp="10l5o9qch8g3w">
            Designed for qualified aesthetic practitioners, dermatology professionals, and licensed clinicians.
          </p>
          <h1 className="font-display text-[29px] font-black uppercase leading-[1.08] tracking-tight sm:text-5xl lg:text-[54px]" data-id="element-212" data-mp="1aj3eukht6ozo">
            Turn post-laser complication observations into a structured clinical action plan{' '}
            <span className="text-gold-400" data-id="element-213" data-mp="4nyazzzkg3yy">in 15 minutes</span>
          </h1>
          <p className="mt-5 text-base leading-relaxed text-white/85 sm:text-lg" data-id="element-214" data-mp="3vu95tedzg8hu">
            Organize findings, document clinical concerns, and identify appropriate escalation pathways using the{' '}
            <strong className="font-bold text-accent-400" data-id="element-215" data-mp="sek8ixby25up">LASER COMPLICATION DECISION MAP™</strong>.
          </p>

          <img src={MOCKUP_URL} alt="Aesthetic Laser Complications Decision Blueprint: 6 clinical volumes and 5 bonuses" className="-mx-2 mt-8 w-[calc(100%+1rem)] max-w-none rounded-2xl bg-white p-2 lg:hidden" data-id="element-216" data-mp="ngil607hjkdf" />

          <div className="mt-8 w-full space-y-3 text-left" data-id="element-217" data-mp="1b4jrd2h6yopo">
            <p className="text-base font-semibold text-white sm:text-lg" data-id="element-218" data-mp="1b637mt2ukzrg">
              Stop relying on scattered notes and inconsistent assessment routines.
            </p>
            <p className="text-base leading-relaxed text-white/80" data-id="element-219" data-mp="30n8hsawgrkoc">
              Build a clear, documented post-laser complication assessment workflow using practical decision
              matrices, structured checklists, and professional escalation tools.
            </p>
          </div>

          <div className="mt-6 flex w-full items-center justify-center gap-3 rounded-2xl bg-navy-800 px-4 py-4 ring-1 ring-accent-500/40 lg:justify-start" data-id="element-220" data-mp="2vu5m9x84m15i">
            <GiftIcon className="h-7 w-7 shrink-0 text-gold-400" aria-hidden="true" data-id="element-221" data-mp="2muiv04942bq6" />
            <p className="font-display text-base font-extrabold uppercase leading-tight sm:text-lg" data-id="element-222" data-mp="2msfyd1dgdkch">
              6 Practical Clinical Volumes <span className="text-gold-400" data-id="element-223" data-mp="2cvtbk71kgj7t">+ 5 Professional Bonuses</span>
            </p>
          </div>

          <div className="mt-8 flex w-full flex-col items-center gap-4 lg:items-start" data-id="element-224" data-mp="65dbcp9f7jgz">
            <CTAButton id="hero-cta" data-id="element-225" data-mp="b4q39of5fgqf">Get the complete blueprint for $27</CTAButton>
            <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm font-medium text-white/85" data-id="element-226" data-mp="1vn0ij5xiwmmu">
              <span className="flex items-center gap-1.5" data-id="element-227" data-mp="1qofq3soij78y">
                <ZapIcon className="h-4 w-4 text-gold-400" aria-hidden="true" data-id="element-228" data-mp="1qlurdcjih7ff" />
                Instant Digital Access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-229" data-mp="20lln1hjt5sh3">
                <ShieldCheckIcon className="h-4 w-4 text-accent-400" aria-hidden="true" data-id="element-230" data-mp="20kag58v2g4lr" />
                7-Day Money-Back Guarantee
              </span>
            </div>
            <p className="max-w-md text-xs leading-relaxed text-white/55" data-id="element-231" data-mp="2abdh8anzwjl1">
              The 15-minute workflow is a practical organization target, not a guarantee of clinical assessment
              time or patient outcomes.
            </p>
          </div>
        </div>

        <div className="hidden lg:block" data-id="element-232" data-mp="twvfzonmrpj0">
          <img src={MOCKUP_URL} alt="Aesthetic Laser Complications Decision Blueprint: 6 clinical volumes and 5 bonuses" className="w-full rounded-3xl bg-white p-4" data-id="element-233" data-mp="txwzmhippkcc" />
        </div>
      </div>
    </header>;
}